{
  "modal_message": "您是否下载了Gucci App？",
  "modal_yes": "是的",
  "modal_no": "不"
}
